import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function FeatureDescription({ textKey }) {
  const { t } = useTranslation()

  const paragraphs = t(textKey, { returnObjects: true })

  return (
    <ul className="feature-description">
      {paragraphs.map((p) => (
        <li className="feature-description__item">{p}</li>
      ))}
    </ul>
  )
}

FeatureDescription.propTypes = {
  textKey: PropTypes.string.isRequired
}

export default FeatureDescription
